import { useAppParams } from "@router/router-helper";
import { NotFoundPage } from "@pages/not-found-page";
import { GeneralSettings } from "@pages/settings/general-settings/general-settings";
import { TabsWithRoutes } from "@components/common/tabs/tabs-with-routes";
import { CircularProgress } from "@faro-lotv/flat-ui";
import { SettingsTabs } from "@router/route-params";
import { OpenTabEvents } from "@utils/track-event/track-event-list";
import { SubscriptionSettings } from "@pages/settings/subscription-settings/subscription-settings";

/** Content in the Workspace Settings page */
export function WorkspaceSettingsPage(): JSX.Element {
  const { settingsTab } = useAppParams();

  if (
    !settingsTab ||
    !Object.values(SettingsTabs).includes(settingsTab)
  ) {
    return <NotFoundPage />;
  }

  const tabs = [
    {
      label: "General",
      route: SettingsTabs.general,
      content: () => <GeneralSettings />,
      loadingContent: <CircularProgress />,
    },
    {
      label: "Subscription",
      route: SettingsTabs.subscription,
      content: () => <SubscriptionSettings />,
      loadingContent: <CircularProgress />,
    },
  ];

  return (
    <TabsWithRoutes
      dataTestId="WORKSPACE_SETTINGS_CONTAINER"
      selectedTab={settingsTab}
      requiredAttribute={false}
      trackingEventPageName={OpenTabEvents.openWorkspaceSettingsTab}
      tabs={tabs}
    />
  );
}
